import React, { useEffect, useState } from 'react';

import Icon from '@components/custom/Icon';

const ModuleHeader = ({ id, title, actions, filters }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className="module-header d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            <Icon name={ id } />
            <span className='text-nowrap'>{ title }</span>
          </div>
          { !isMobile && (
            <> { filters } </>
          )}
        </div>
        <div className="actions">
          { actions }
        </div>
      </div>
      {isMobile && (
        <div className='module-header mobile'> { filters } </div>
      )}
    </>
  );
};

export default ModuleHeader;
